import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logo-full-gold.svg")